<div class="dashboard container" style="padding: 0 1rem; text-align: center;">
      <div class="d-flex justify-content-end">
        <button mat-icon-button (click)="close()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="header-container title-container">
        <i class="bi bi-check-circle" style="color:#007a47; transform: scale(2); display:inline-block; text-align: center;"></i>
        <h6 class="text-title title mt-3">Evaluación enviada con éxito</h6>
      </div>

      <p style="text-align:center">
        Agradecemos tu evaluación. Así nos ayudarás a mejorar.
      </p>

      <div class="d-flex justify-content-center">
        <button mat-raised-button color="primary" (click)="close()">Cerrar</button>
      </div>
    </div>

